<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center mt-3 class="cont_page">
          <v-flex xs12 sm7 md7>
          <!-- dialogo tuca -->
            <v-layout class="animated fadeInLeft dura-1" row>
              <div class="imagen-personaje"><img src="@/assets/imagenes_compartidas/tucan-1.png" alt=""></div>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>Agora, ouça o professor: Oi, professor Eduardo!</p>
              </v-flex>
            </v-layout>
          <!-- dialogo hombre -->
            <v-layout class="animated fadeInRight dura-3" row mt-3>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>Oi, Tuca!  Quem é o seu amigo? </p>
              </v-flex>
              <div class="imagen-personaje-hombre"></div>
            </v-layout>
          <!-- dialogo tuca -->
            <v-layout class="animated fadeInLeft dura-5" row mt-3>
              <div class="imagen-personaje"><img src="@/assets/imagenes_compartidas/tucan-1.png" alt=""></div>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>É um aluno novo. Você poderia lhe dizer como nos apresentamos em português?</p>
              </v-flex>
            </v-layout>
          <!-- dialogo hombre -->
            <v-layout class="animated fadeInRight dura-7" row mt-3>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>Claro que sim, amigo! Vamos ver? <b>Clique em avançar.</b></p>
              </v-flex>
              <div class="imagen-personaje-hombre"></div>
            </v-layout>

          </v-flex>
        </v-layout>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Neste nível, você verá os siguientes temas: vamos lá?'
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit('nextShow', true);
    }, 5000);
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

.imagen-personaje{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -20px;
  z-index: 1;
      img {
        width: 70px;
    }
}
.cont-dialogo{
  background: #81C7FD;
  padding: 10px 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  p{
    margin: 0;
    padding: 0;
    font-family:Poppins-Regular;
    font-size: 13px;

  }
}
.imagen-personaje-hombre{
  background: url('../../assets/unidad1/slide-3-1.jpg')no-repeat 70% 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -20px;
  z-index: 1;
  width: 70px;
  height: 70px;
  background-size: 110px;
  border-radius: 50%;
}

</style>
